import React from "react";
import { Flex, Avatar, Box, Text } from "@chakra-ui/react";
const ProfileBadge = ({ name, email }) => {
  return (
    <Flex p={2}>
      <Avatar name={name} bg="red.50" color="gray.600" />
      <Box ml="3">
        <Text fontWeight="bold" fontSize="md">
          {name}
        </Text>
        <Text fontSize="xs" color="gray.600">{email}</Text>
      </Box>
    </Flex>
  );
};

export default ProfileBadge;
